function cov_1bewvppl5c() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/TrashFilled.tsx";
  var hash = "4b1c77db6abcf2cd750081b9b38a0ea27e4cc1be";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/TrashFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4b1c77db6abcf2cd750081b9b38a0ea27e4cc1be"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bewvppl5c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bewvppl5c();
var Icon = (cov_1bewvppl5c().s[0]++, {
  name: 'trash-filled',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M7.3077 20.5C6.81058 20.5 6.38502 20.323 6.03102 19.9689C5.67701 19.6149 5.5 19.1894 5.5 18.6923V5.99999H5.25C5.0375 5.99999 4.85938 5.92808 4.71563 5.78427C4.57188 5.64047 4.5 5.46227 4.5 5.24967C4.5 5.03708 4.57188 4.859 4.71563 4.71542C4.85938 4.57182 5.0375 4.50002 5.25 4.50002H8.99997C8.99997 4.25515 9.08619 4.0465 9.25863 3.87407C9.43106 3.70163 9.63971 3.61542 9.88457 3.61542H14.1154C14.3602 3.61542 14.5689 3.70163 14.7413 3.87407C14.9138 4.0465 15 4.25515 15 4.50002H18.75C18.9625 4.50002 19.1406 4.57193 19.2843 4.71574C19.4281 4.85956 19.5 5.03776 19.5 5.25034C19.5 5.46294 19.4281 5.64103 19.2843 5.78462C19.1406 5.9282 18.9625 5.99999 18.75 5.99999H18.5V18.6923C18.5 19.1894 18.3229 19.6149 17.9689 19.9689C17.6149 20.323 17.1894 20.5 16.6922 20.5H7.3077ZM9.40385 17H10.9038V7.99999H9.40385V17ZM13.0961 17H14.5961V7.99999H13.0961V17Z\" fill=\"currentColor\"/>"
});
export default Icon;